import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKeyPlus = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M13.664 4c-4.737 0-8.6 3.862-8.6 8.6v25.8c0 4.738 3.863 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6c0-4.738-3.862-8.6-8.6-8.6h-22.8zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6V12.6c0-3.657 2.944-6.6 6.6-6.6zm10.4 8v7h-7v2h7v7h2v-7h7v-2h-7v-7h-2zm-17 22.902a8.588 8.588 0 0 0 6.6 3.098h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6v-1.498z" />
    </svg>
);
export default SvgKeyPlus;
